import { useState, useEffect } from 'react'
import { useRegionId } from '@/shared/hooks/use-region-id'
import { authFetchJson } from '@/shared/lib/auth-fetch'

export function useActiveWorkScopes() {
    const { regionId } = useRegionId()
    const [activeWorkScopes, setActiveWorkScopes] = useState<Record<string, boolean>>({})
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        async function fetchActiveWorkScopes() {
            if (!regionId) {
                setActiveWorkScopes({})
                setLoading(false)
                return
            }

            try {
                setLoading(true)
                setError(null)
                const res = await authFetchJson<Record<string, boolean>>(`/work-scopes/active-for-region?regionId=${regionId}`)
                
                const activeScopes = (res as any)?.success === false ? {} : ((res as any)?.success ? (res as any).data : res)
                if (activeScopes && typeof activeScopes === 'object') {
                    setActiveWorkScopes(activeScopes)
                } else {
                    setActiveWorkScopes({})
                }
            } catch (err) {
                setError(err instanceof Error ? err.message : 'An error occurred')
                console.error('Error fetching active work scopes:', err)
                // Default to all active if there's an error (don't hide sections)
                setActiveWorkScopes({})
            } finally {
                setLoading(false)
            }
        }

        fetchActiveWorkScopes()
    }, [regionId])

    return { activeWorkScopes, loading, error }
}

